import i18n from '@/utils/i18n';
import React from 'react';
import SnapPeasImage from '@assets/icons/snap-peas-image.svg';
import { Props as ButtonProps } from './button';
import { EmptyStateCard } from './empty-state-card';
import { Text } from 'react-native';
import { TYPOGRAPHY } from '@/styles';
import { useTheme } from '@/contexts/theme-context';

interface Props {
  buttonProps: ButtonProps;
  children?: React.ReactNode;
}

export const SnapPeasCard: React.FC<Props> = ({ children, buttonProps }) => {
  const theme = useTheme();
  return (
    <EmptyStateCard
      buttonProps={buttonProps}
      iconProps={{
        accentFill: theme.colors.accent,
      }}
      ImageComponent={SnapPeasImage}
      showBackground={false}
    >
      <Text style={TYPOGRAPHY.cardHeaderText}>{i18n.t('oh_snap_peas')}</Text>
      {children}
    </EmptyStateCard>
  );
};
